// extracted by mini-css-extract-plugin
export default {"trio":"styles_trio__tBiFZ","twoBig":"styles_twoBig__ZUdlw","reverse":"styles_reverse__jVwy8","two":"styles_two__2rwez","twoReverse":"styles_twoReverse__M93IZ"};